module.exports = __webpack_public_path__ + "static/img/51.74b600c.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/Microsoft365Security/51.png
// module id = xAwb
// module chunks = 1